import { useCallback, useRef } from "react";

type Timer = ReturnType<typeof setTimeout>;

export function useDebounce<F extends (...args: any[]) => void>(
  func?: F,
  delay?: number,
): (...args: Parameters<F>) => void {
  let timer = useRef<Timer>().current;

  return useCallback(function debouncedFn(...args: Parameters<F>) {
    clearTimeout(timer);
    timer = setTimeout(() => {
      func && func(...args);
    }, delay);
  }, []);
}
